export default "__VITE_ASSET__Dgv1R4EJ__"